import dayjs from 'dayjs';

export function convertDateToISODate(str: string) {
  return new Date(str).toISOString();
}

export function convertDateToFormattedStr(str?: string) {
  if (str) {
    return dayjs(str).format('YYYY-MM-DD');
  }
}
